module.exports = __webpack_public_path__ + "img/15.1.07413259.jpg";